module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"edit field":"Edit field","type":"Type","input type":"Input type","label":"Label","button text":"Button text","text":"Text"}}')
  delete Component.options._Ctor
}
